export default __webpack_public_path__ + "static/ban3-7ee9b298d3deaa58ae1a23647672ea73.png";